import React, {useEffect, useRef} from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import ImportingLottieAnimation from "../../../../../components/app-specific/lottie-animations/importing";
import {LinearProgress, Tooltip, Typography} from "@mui/material";


const ExportingProgress = ({progress}) => {
    const containerRef = useRef(null);

    /**
     * Scrolls the export progress animation into view when exporting starts.
     */
    useEffect(() => {
        containerRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }, []);

    return (
        <div ref={containerRef}>
            <Grid2 container spacing={2}>
                <Grid2 xs={12}>
                    <div className={'d-flex flex-column py-4'}>
                        <ImportingLottieAnimation width={'80%'} height={'50vh'} className={''}/>
                        <Tooltip open={true} placement={'top'} arrow title={progress.message}>
                            <div className={'d-flex flex-column w-100 py-3 align-items-center'}>
                                <LinearProgress
                                    className={'w-80'}
                                    variant={'buffer'}
                                    color={'secondary'}
                                    value={progress.percentage}
                                    valueBuffer={progress.percentage}
                                />
                                <p className={'identifier'}>{`${Math.round(progress.percentage)}%`}</p>
                            </div>
                        </Tooltip>
                        <Typography variant={'body2'} className={'mb-2'} textAlign={'center'}>
                            Please do not close this dialog until the exporting is complete.
                        </Typography>
                    </div>
                </Grid2>
            </Grid2>
        </div>
    );
}

export default ExportingProgress;
